/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import divorcePlannerStyle from "./divorcePlannerStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import checklistImage from "../../assets/img/planner/icon_checklist_150px.png";
import ChecklistRow from "./Checklist/ChecklistRow";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { STATUS_CHECKED, STATUS_DOCUMENTS_COMPLETE, STATUS_POWER_OF_ATTORNEY_GRANTED, STATUS_SUBMITTED } from "../../services/divorce/leadStatus";
import autoBind from "react-autobind";
import _set from "lodash/set";
import _get from "lodash/get";
import _merge from "lodash/merge";
import Button from "@mui/material/Button";
import * as PropTypes from "prop-types";
import { getCaseLink } from "../../services/productService";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

class DivorcePlannerChecklists extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }

  componentDidMount() {
    this.setState({ checklist: this.props.divorce.checklist });
  }

  onChange = ({ target }) => {
    this.setState({ checklist: _set(_merge({}, this.state.checklist), target.name, target.checked) });
    this.props.saveChecklist(_set(_merge({}, this.props.divorce.checklist), target.name, target.checked));
  };

  isChecked = (name) => {
    return _get(this.state.checklist, name, false);
  };

  render() {
    const { divorce, hasInsurance } = this.props;
    return (
      <Paper sx={divorcePlannerStyle.contentContainer} elevation={4}>
        <Box id={this.props.id} sx={divorcePlannerStyle.scrollToAnchor} />
        <Grid container justifyContent={"center"} sx={divorcePlannerStyle.headlineContainer}>
          <Grid item xs={12}>
            <Grid container alignItems={"center"}>
              <Grid item xs={5}>
                <Box sx={divorcePlannerStyle.imageContainer}>
                  <Paper sx={divorcePlannerStyle.imageCircle}>
                    <img src={checklistImage} alt={"Meine Checklisten"} />
                  </Paper>
                </Box>
              </Grid>
              <Grid item xs={7}>
                <Box sx={divorcePlannerStyle.contentName}>Meine Checklisten</Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <div>
          <Box id={"checkliste_scheidung"} sx={divorcePlannerStyle.scrollToAnchor} />
          <Typography variant={"h5"} sx={divorcePlannerStyle.checklistHeader}>
            <strong>Scheidung einreichen</strong>
          </Typography>
          <p>Damit wir den Scheidungsantrag bei Gericht einreichen können, müssen Sie sich um Folgendes kümmern:</p>

          <Box sx={divorcePlannerStyle.checklistContainer}>
            <ChecklistRow label={"Angaben für Scheidungsantrag vervollständigen"} checked={true} />
            <ChecklistRow label={"Uns die Vollmacht erteilen"} checked={divorce.leadStatus >= STATUS_POWER_OF_ATTORNEY_GRANTED} />
            <ChecklistRow
              label={"Heiratsurkunde hochladen"}
              description={
                "Wenn Sie Ihnen nicht mehr vorliegt, können Sie die Heiratsurkunde bei dem entsprechenden Standesamt neu beantragen. Dies geht oftmals auch online und dauert ca. 14 Tage."
              }
              checked={divorce.leadStatus >= STATUS_DOCUMENTS_COMPLETE}
              isChecked={this.isChecked("divorce.marriageCertificate")}
              name={"divorce.marriageCertificate"}
              onChange={this.onChange}
            />

            {divorce.numberChildren !== 0 && (
              <ChecklistRow
                label={"Geburtsurkunde" + (divorce.numberChildren > 1 ? "n" : "") + " hochladen"}
                description={
                  "Wenn Sie Ihnen nicht mehr" +
                  (divorce.numberChildren > 1 ? "vorliegen, können Sie die Urkunden" : "vorliegt, können Sie die Urkunde") +
                  " bei dem entsprechenden Standesamt neu beantragen. Dies geht oftmals auch online und dauert ca. 14 Tage."
                }
                checked={divorce.leadStatus >= STATUS_DOCUMENTS_COMPLETE}
                isChecked={this.isChecked("divorce.birthCertificates")}
                name={"divorce.birthCertificates"}
                onChange={this.onChange}
              />
            )}
            {divorce.pensionsExcluded && !divorce.shortMarriage && (
              <ChecklistRow
                label={"Dokument zum Ausschluss des Versorgungsausgleichs hochladen "}
                checked={divorce.leadStatus >= STATUS_CHECKED}
                isChecked={this.isChecked("divorce.pensionsUpload")}
                name={"divorce.pensionsUpload"}
                onChange={this.onChange}
              />
            )}

            {divorce.hasProcessCostSupport && (
              <ChecklistRow
                label={
                  <div>
                    Antrag auf Verfahrenskostenhilfe ausfüllen und Belege hochladen -
                    <Link to={getCaseLink(divorce) + "/vkh-assistent"}> Jetzt Antrag stellen </Link>
                  </div>
                }
                checked={divorce.leadStatus >= STATUS_CHECKED}
                isChecked={this.isChecked("divorce.pcsApplication")}
                name={"divorce.pcsApplication"}
                onChange={this.onChange}
              />
            )}

            {!divorce.hasProcessCostSupport && !hasInsurance && (
              <ChecklistRow
                label={"Verfahrensgebühr bezahlen"}
                checked={divorce.leadStatus >= STATUS_CHECKED}
                isChecked={this.isChecked("divorce.processPaid")}
                name={"divorce.processPaid"}
                onChange={this.onChange}
              />
            )}

            <ChecklistRow
              label={"Trennungsjahr"}
              description={
                "Sie sind seit einem Jahr von Ihrem Ehepartner getrennt und leben bestenfalls in getrennten Wohnungen. Der Scheidungsantrag kann in der Regel einige Wochen vor Ablauf des Trennungsjahres eingereicht werden, sofern keine Streitigkeiten oder Besonderheiten auftreten."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("divorce.separarionYear")}
              name={"divorce.separarionYear"}
              onChange={this.onChange}
            />
          </Box>
        </div>

        {divorce.hasProcessCostSupport && divorce.netIncomePetitioner >= 800 && (
          <>
            <Box sx={divorcePlannerStyle.checklist}>
              <Box id={"checkliste_verfahrenskostenhilfe"} sx={divorcePlannerStyle.scrollToAnchor} />
              <Typography variant={"h5"} sx={divorcePlannerStyle.checklistHeader}>
                <strong>Verfahrenskostenhilfe</strong>
              </Typography>
              <p>
                <strong>Wenn Ihnen die Kosten für eine Scheidung zu hoch sind, gibt es zwei Möglichkeiten:</strong>
                <br />
              </p>
              <ol>
                <li>
                  <strong>Sie beantragen Verfahrenskostenhilfe beim Gericht</strong>
                  <br />
                  Für den Antrag müssen Sie Ihre finanzielle Situation detailiert belegen und das Gericht 4 Jahre lang bei Veränderungen Ihrer finanziellen
                  Situation umgehend informieren. Wird die Verfahrenskostenhilfe bewilligt, müssen Sie die Kosten entweder per monatlicher Rate an das Gericht
                  zurückzahlen oder das Gericht übernimmt die Kosten für Sie.
                </li>
                <li>
                  <strong>Sie bezahlen bequem per Finanzierung</strong>
                  <br />
                  Bei einer Finanzierung können Sie die Bezahlung der Scheidungskosten an Ihre finanzielle Situation anpassen. Sprechen Sie uns hierzu gerne an
                  und wir finden eine Lösung, die für Sie am besten passt.
                </li>
              </ol>
              <p>
                <strong>
                  Die Beantragung von Verfahrenskostenhilfe ist sehr umfangreich und bringt einige Verpflichtungen mit sich. Folgendes sollten Sie daher im
                  Vorfeld bedenken:
                </strong>
              </p>
              <ul>
                <li>Durch die Beantragung der Verfahrenskostenhilfe verzögert sich der Beginn des Scheidungsverfahrens um ein bis zwei Monate.</li>
                <li>
                  Ihre komplette finanzielle Situation muss offen gelegt werden, daher muss das vierseitige Antragsformular ausgefüllt und alle Angaben mit
                  Belegen versehen werden.
                </li>
                <li>
                  Die Bewilligung der Verfahrenskostenhilfe geschieht vorläufig, ist widerruflich und bleibt nur wirksam, wenn Sie in den auf die Bewilligung
                  folgenden vier Jahren an wiederholten Überprüfungen durch das Gericht mitwirken.
                </li>
                <li>
                  In der Regel überprüft das Gericht die Verfahrenskostenhilfe-Berechtigung nach zwei Jahren erneut. Sie werden dann vom Gericht angeschrieben
                  und gebeten, das Formular erneut auszufüllen und mit Belegen zurück zu senden.
                </li>
                <li>
                  Sie müssen zudem vier Jahre lang von sich aus jede Veränderung Ihrer finanziellen Situation dem Gericht mitteilen, ebenso jede Adressänderung.
                  Dies bezieht sich sowohl auf Einkommenssteigerungen von mehr als 100 € pro Monat als auch auf die Ablösung bestehender Kredite oder die
                  Aufnahme neuer Kredite.
                </li>
                <li>
                  Verstoßen Sie gegen diese Pflichten, kann die Verfahrenskostenhilfe widerrufen werden und Sie müssen die gesamten Kosten an das Gericht
                  zurückzahlen.
                </li>
              </ul>
              <p>
                <Box component="strong" sx={divorcePlannerStyle.primary}>
                  TIPP:
                </Box>{" "}
                Alternativ zum Antrag auf Verfahrenskostenhilfe können Sie die Scheidungskosten auch finanzieren. Welche Möglichkeiten es hier gibt, besprechen
                wir gerne direkt mit Ihnen.
              </p>
            </Box>
            <Typography sx={{ textAlign: "center" }}>
              <strong>Sie haben sich für die Verfahrenskostenhilfe entschieden? Unser Verfahrenskostenhilfe-Assistent hilft Ihnen bei Ihrem Antrag!</strong>
            </Typography>
            <p>
              <Button fullWidth={true} component={Link} to={getCaseLink(divorce) + "/vkh-assistent"} variant={"text"} color={"primary"}>
                Jetzt Beantragen
              </Button>
            </p>
          </>
        )}

        <Box sx={divorcePlannerStyle.checklist}>
          <Box id={"checkliste_trennung"} sx={divorcePlannerStyle.scrollToAnchor} />
          <Typography variant={"h5"} sx={divorcePlannerStyle.checklistHeader}>
            <strong>Tipps für eine reibungslose Trennung</strong>
          </Typography>
          <p>
            Damit Ihre Scheidung durchgeführt werden kann, muss Ihre Ehe gescheitert sein. Eine Ehe ist laut Gesetz nur dann gescheitert, wenn die Ehepartner
            ein Jahr getrennt voneinander leben. Damit diese Trennung auch gesetzlich anerkannt wird und möglichst reibungslos verläuft, sollten Sie folgende
            Punkte beachten:
          </p>

          <Box sx={divorcePlannerStyle.checklistContainer}>
            <ChecklistRow
              label={"Trennungsdatum dokumentieren"}
              description={
                "Dokumentieren Sie das Trennungsdatum zusammen mit Ihrem Ehepartner - dies kann formlos in einem Dokument erfolgen, das beide Ehepartner unterschreiben. Sollte Ihr Ehepartner dies nicht tun wollen, können Sie dies auch einseitig bekunden und ihm das Schreiben unter Beisein eines Zeugen übergeben."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.documented")}
              name={"separation.documented"}
              onChange={this.onChange}
            />
            <ChecklistRow
              label={"Eigenen Wohnraum suchen"}
              description={
                "Suchen Sie sich zum nächstmöglichen Zeitpunkt eine eigene Wohnung bzw. einigen Sie sich mit Ihrem Eheparnter darauf, dass er auszieht. Dies vereinfacht im Zweifel den Nachweis, dass die Ehe gescheitert ist. Regeln Sie hierzu auch die Änderung des Mietvertrages. Sollten Sie den gemeinsamen Wohnraum verlassen, denken Sie daran eigene Wertgegenstände mitzunehmen."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.residence")}
              name={"separation.residence"}
              onChange={this.onChange}
            />
            <ChecklistRow
              label={"Aufteilung des Hausrats"}
              description={"Dokumentieren Sie bestenfalls schriftlich, wie Sie den Hausrat untereinander aufteilen möchten."}
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.household")}
              name={"separation.household"}
              onChange={this.onChange}
            />
            <ChecklistRow
              label={"Bankkonten trennen"}
              description={
                "Im Falle eines gemeinsamen Kontos lösen Sie dieses umgehend auf, da Sie sich auch finanziell voneinander trennen müssen. Alle Zahlungsein- und -ausgänge sollten zukünftig über Ihr eigenes Konto laufen. Hat Ihr Ehepartner eine Vollmacht zu Ihrem Konto, widerrufen Sie diese umgehend bei der Bank. Lassen Sie zudem ggf. EC-Partnerkarten zu Ihrem Konto, die Ihr Ehepartner nutzt, sperren."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.bankAccounts")}
              name={"separation.bankAccounts"}
              onChange={this.onChange}
            />
            <ChecklistRow
              label={"Kredite und Verträge"}
              description={
                "Versuchen Sie bei gemeinsamen Krediten oder Verträgen diese ebenfalls zu trennen und ggf. neue Verträge aufzusetzen. Sollten Kredite Ihres Ehepartners  über Ihr Konto abgebucht werden, widerrufen Sie die Lastschriften."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.creditContracts")}
              name={"separation.creditContracts"}
              onChange={this.onChange}
            />
            <ChecklistRow
              label={"Finanzamt benachrichtigen"}
              description={
                "Teilen Sie dem Finanzamt mit, dass Sie getrennt sind – dies müssen Sie sowieso spätestens zum Folgekalenderjahr der Trennung getan haben. Kontaktieren Sie hierzu im Zweifel Ihren Steuerberater und bewahren Sie in jedem Fall eine Kopie des Formulars auf."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.taxOffice")}
              name={"separation.taxOffice"}
              onChange={this.onChange}
            />
            <ChecklistRow
              label={"Kopien wichtiger Dokumente"}
              description={
                "Fertigen Sie Kopien aller wichtigen Dokumente an. Dies können z.B. Grundbuchauszüge, Kreditverträge, Lebensversicherungen, Einkommensnachweise (auch Ihres Ehepartners) oder ähnliche Dokumente und Verträge sein. Für die Einreichung des Scheidungsantrags benötigen Sie in jedem Fall die Heiratsurkunde und bei gemeinsamen Kindern unter 18 auch deren Geburtsurkunden."
              }
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.documents")}
              name={"separation.documents"}
              onChange={this.onChange}
            />
            {!divorce.pensionsExcluded && (
              <ChecklistRow
                label={"Kontenverlauf bei Rentenversicherung anfragen"}
                description={
                  <span>
                    Für den Versorgungsausgleich können Sie schon jetzt bei Ihren Rentenversicherungen einen Kontenverlauf anfordern, um eventuelle Lücken
                    während Ihrer Ehezeit nachgehen und bei ehemaligen Arbeitgebern noch fehlende Dokumente anfordern zu können. Gleiches gilt für Ihren
                    Ehepartner. So sparen Sie viel Zeit bei der Dauer der Scheidung ein. Entsprechende Links finden Sie{" "}
                    <HashLink to={"/scheidung/scheidungsdauer/#rentenansprueche-klaeren"}>hier</HashLink>.
                  </span>
                }
                checked={divorce.leadStatus >= STATUS_SUBMITTED}
                isChecked={this.isChecked("separation.pensionInsurance")}
                name={"separation.pensionInsurance"}
                onChange={this.onChange}
              />
            )}
            {!divorce.pensionsExcluded && (
              <ChecklistRow
                label={"Informationen für Fragebogen zum Versorgungsausgleich besorgen"}
                description={
                  "Klären Sie schon jetzt alle Arbeitgeber, bei denen Sie in der Zeit der Ehe gearbeitet haben und bei denen Sie Rentenansprüche erworben haben. Diese müssen Sie später im Fragebogen zum Versorgungsausgleich zusammen mit Ihrer Rentenversicherungsnummer angeben. Suchen Sie auch die Angaben zu allen Rentenversicherungsträgern heraus, bei denen Sie Ansprüche erworben haben - ganz gleich, ob diese Ansprüche noch bestehen oder bereits ausgezahlt wurden."
                }
                checked={divorce.leadStatus >= STATUS_SUBMITTED}
                isChecked={this.isChecked("separation.pensionSurvey")}
                name={"separation.pensionSurvey"}
                onChange={this.onChange}
              />
            )}
            {!divorce.pensionsExcluded && (
              <ChecklistRow
                label={"Fragebogen zum Versorgungsausgleich ausfüllen"}
                description={
                  <span>
                    Um bei der Berechnung des Versorgungsausgleichs Zeit zu sparen, können Sie bereits jetzt den Fragebogen zum Versorgungsauslgeich ausfüllen.
                    Den Fragebogen können Sie{" "}
                    <a href="/documents/Formular_Versorgungsausgleich.pdf" download="Formular_Versorgungsausgleich">
                      <strong>hier direkt herunterladen</strong>
                    </a>
                    . Leiten Sie diesen auch an Ihren Ehepartner weiter. Liegt uns der Fragebogen bereits bei der Einreichung Ihres Scheidungsantrags vor,
                    werden wir diesen direkt mit einreichen, sodass die Dauer der Scheidung deutlich verkürzt wird.
                  </span>
                }
                checked={divorce.leadStatus >= STATUS_SUBMITTED}
                isChecked={this.isChecked("separation.pensionSurveyFill")}
                name={"separation.pensionSurveyFill"}
                onChange={this.onChange}
              />
            )}

            {divorce.numberChildren > 0 && (
              <ChecklistRow
                label={"Betreuung der Kinder im Trennungsjahr"}
                description={
                  <span>
                    Besprechen Sie zeitnah und am besten gemeinsam mit Ihren Kindern, wer sie hauptsächlich im Trennungsjahr betreut und bei wem sie wohnen
                    sollen. Unsere Tipps hierzu finden Sie <HashLink to={"#kinder"}>hier</HashLink>.
                  </span>
                }
                checked={divorce.leadStatus >= STATUS_SUBMITTED}
                isChecked={this.isChecked("separation.childrenSupervision")}
                name={"separation.childrenSupervision"}
                onChange={this.onChange}
              />
            )}

            {divorce.numberChildren > 0 && (
              <ChecklistRow
                label={"Kindesunterhalt berechnen"}
                description={"Berechnen Sie, wer wie viel Unterhalt für die Kinder zahlen muss."}
                checked={divorce.leadStatus >= STATUS_SUBMITTED}
                isChecked={this.isChecked("separation.childSupport")}
                name={"separation.childSupport"}
                onChange={this.onChange}
              />
            )}

            <ChecklistRow
              label={"Trennungsunterhalt berechnen"}
              description={"Prüfen Sie Ihren Anspruch auf Trennungsunterhalt, oder ob Sie Ihrem Partner Trennungsunterhalt zahlen müssen."}
              checked={divorce.leadStatus >= STATUS_SUBMITTED}
              isChecked={this.isChecked("separation.separationSupport")}
              name={"separation.separationSupport"}
              onChange={this.onChange}
            />
          </Box>
        </Box>
      </Paper>
    );
  }
}

DivorcePlannerChecklists.propTypes = {
  hasInsurance: PropTypes.bool,
};

DivorcePlannerChecklists.defaultProps = {
  hasInsurance: false,
};

export default DivorcePlannerChecklists;
